import { jsx as s } from "react/jsx-runtime";
import { forwardRef as m } from "react";
import x from "@mui/material/FormControlLabel";
import b from "styled-components";
import "../LabelTooltip/LabelTooltip.js";
import n from "../LabelTooltip/utils.js";
const d = {
  root: "formControlLabelRoot",
  label: "formControlLabelLabel",
  disabled: "formControlLabelDisabled",
  asterisk: "labelAsterisk"
}, L = (o, a, r) => {
  let t = "0px 0px 0px 0px";
  switch (a) {
    case "end":
      t = `0px 0px 0px ${o ? `${r[3]}px` : "0px"}`;
      break;
    case "start":
      t = `0px ${o ? `${r[1]}px` : "0px"} 0px 0px`;
      break;
    case "top":
      t = `0px 0px ${o ? `${r[2]}px` : "0px"} 0px`;
      break;
    case "bottom":
      t = `${o ? `${r[0]}px` : "0px"} 0px 0px 0px`;
      break;
  }
  return t;
}, f = b(x).withConfig({
  displayName: "StyledFormControlLabel"
})([
  "&&.formControlLabelRoot{margin:0px;width:",
  ";}&& .formControlLabelLabel{margin:",
  ";line-height:16px;}&& .formControlLabelDisabled{color:",
  ";}&&.formControlLabelRoot .labelAsterisk{color:",
  ";}"
], ({ $fullWidth: o }) => o ? "100%" : "auto", ({ label: o, labelPlacement: a, $labelPlacementOffset: r }) => L(o, a, r), ({ theme: o }) => o.secondaryDisabled, ({ theme: o }) => o.caution), C = /* @__PURE__ */ m(({ classes: o, fullWidth: a = !1, labelPlacementOffset: r = [
  8,
  8,
  8,
  8
], value: t = "off", label: l = void 0, tooltip: e = void 0, ...p }, i) => /* @__PURE__ */ s(f, {
  ...p,
  ref: i,
  classes: {
    ...d,
    ...o
  },
  value: t,
  $fullWidth: a,
  $labelPlacementOffset: r,
  label: n(l, e)
}));
C.displayName = "FormControlLabel";
export {
  C as default
};
